'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _components = require('../../components');

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListSriUssifIcon = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListSriUssifIcon, _Component);

  //
  function IyvListSriUssifIcon(props) {
    (0, _classCallCheck3.default)(this, IyvListSriUssifIcon);

    //
    var _this = (0, _possibleConstructorReturn3.default)(this, (IyvListSriUssifIcon.__proto__ || (0, _getPrototypeOf2.default)(IyvListSriUssifIcon)).call(this, props));

    var isUssif = _convert2.default.float(props.ussif) === 1.5;
    var isSri = _convert2.default.boolean(props.sri);
    var fundSriTooltip = isSri ? _format2.default.tooltipHtml('Reports a Sustainability Mandate to Morningstar') : _format2.default.tooltipHtml('No Sustainability Mandate');
    //
    _this.state = {
      isUssif: isUssif,
      isSri: isSri,
      fundSriTooltip: fundSriTooltip
    };
    return _this;
  }
  //


  (0, _createClass3.default)(IyvListSriUssifIcon, [{
    key: 'render',
    value: function render() {
      var ussifLogo = require('../../../static/images/ussif-icon.png');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'sri-wrapper' },
        _react2.default.createElement(
          'div',
          {
            style: { display: 'inline-block' },
            'data-multiline': true,
            'data-effect': 'solid',
            'data-tip': this.state.fundSriTooltip,
            'data-html': true,
            'data-place': 'bottom',
            'data-for': 'sri-icon-tooltip'
          },
          _react2.default.createElement(_components.YesNo, { yes: this.state.isSri })
        ),
        _react2.default.createElement(_reactTooltip2.default, { id: 'sri-icon-tooltip' }),
        /* if there's a US-SIF badge: show an image */
        this.state.isUssif ? _react2.default.createElement('img', { styleName: 'ussif-badge-img',
          src: ussifLogo,
          alt: 'Member of The Forum for Sustainable and ' + 'Responsible Investment',
          'data-multiline': true,
          'data-effect': 'solid',
          'data-tip': _format2.default.tooltipHtml('Member of US-SIF, the Forum for Sustainable ' + 'and Responsible Investment'),
          'data-html': true,
          'data-place': 'bottom',
          'data-for': 'ussif-' + this.props.id
        }) : null,
        _react2.default.createElement(_reactTooltip2.default, { id: 'ussif-' + this.props.id })
      );
    }
  }]);
  return IyvListSriUssifIcon;
}(_react.Component), _class2.propTypes = {
  ussif: _react.PropTypes.string, // ugh
  sri: _react.PropTypes.string,
  id: _react.PropTypes.string,
  mobile: _react.PropTypes.bool
}, _temp)) || _class);
var IyvListTdSriUssif = (_dec2 = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(IyvListTdSriUssif, _Component2);

  //
  function IyvListTdSriUssif(props) {
    (0, _classCallCheck3.default)(this, IyvListTdSriUssif);

    //
    var _this2 = (0, _possibleConstructorReturn3.default)(this, (IyvListTdSriUssif.__proto__ || (0, _getPrototypeOf2.default)(IyvListTdSriUssif)).call(this, props));

    var isUssif = _convert2.default.float(props.shareclass.ussif) === 1.5;
    var isSri = _convert2.default.boolean(props.shareclass.socially_responsible_fund);
    var fundSriTooltip = isSri ? _format2.default.tooltipHtml('Reports a Sustainability Mandate to Morningstar') : _format2.default.tooltipHtml('No Sustainability Mandate');
    //
    _this2.state = {
      isUssif: isUssif,
      isSri: isSri,
      fundSriTooltip: fundSriTooltip
    };
    return _this2;
  }
  //


  (0, _createClass3.default)(IyvListTdSriUssif, [{
    key: 'render',
    value: function render() {
      var ussifLogo = require('../../../static/images/ussif-icon.png');
      //
      return _react2.default.createElement(
        'td',
        {
          styleName: 'col',
          onClick: this.props.mobile ? function () {} : this.props.clickShareclass(this.props.shareclass)
        },
        _react2.default.createElement(IyvListSriUssifIcon, {
          ussif: this.props.shareclass.ussif,
          sri: this.props.shareclass.socially_responsible_fund,
          id: this.props.shareclass.investment_vehicle_id
        })
      );
    }
  }]);
  return IyvListTdSriUssif;
}(_react.Component), _class4.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickShareclass: _react.PropTypes.func,
  mobile: _react.PropTypes.bool
}, _temp2)) || _class3);
exports.default = IyvListTdSriUssif;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListTdSriUssif.js
// module id = 1338
// module chunks = 0